export const tr = {
    pageHeader: 'Uzman anketi: {fullName}',
    saveError: 'Anket güncellenemedi, daha sonra tekrar deneyin.'
};
